import React, { useState, } from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col, Hidden, } from 'react-grid-system';
import _ from 'lodash'

import { StyledDialogTag, InputStyle, InputReadOnlyStyle, } from './StyledDialogTag'

import Dialog from '../modal'
import Input from '../input'
import Button from '../button'

import { Colors, Images, } from '../../themes'

import { relationshipList } from '../../data/RelationshipList'

import { getPartners } from '../../api/UserAPI'

import ProccessData from '../../lib/ProccessData'

function TagDementia({
  dialogProps,
  otherAccount,
  onTagAccount,
  loadingTag,
}) {

  const [inputValue, setInputValue] = useState({
    organizationName: '',
  })
  const [users, setUsers] = useState({
    loading: false,
    data: [],
  })
  const [dropdowns,setDropdowns] = useState({
    relationship: {
      showDropdown: false,
      value: '',
    },
  });
  const [loading, setLoading] = useState(false)
  const [searched, setSearched] = useState(false)
  const [userSelected, setUserSelected] = useState({})

  const { relationship } = dropdowns
  const { organizationName, } = inputValue

  const renderInputDropdown = (props) => {
    const { value, onClick, } = props;
    let filtered = true
  
    return (
      <Col md={12}>
        <Input
          inputProps={{
            readOnly: true,
            onClick: filtered ? onClick : null,
            value,
          }}
          containerStyle={`
            ${InputReadOnlyStyle}
            .input-field {
              cursor: ${filtered ? 'pointer' : 'not-allowed'}
            }
            input {
              color: ${filtered ? Colors.color2 : Colors.color34} !important;
            }
          `}
          iconRight={Images.polygonYellow}
          {...props}
          dropdownWidth={'100%'}
        />
      </Col>
    );
  }

  const onPressDropdown = (stateName) => {
    setDropdowns(state => {
      return { ...state, [stateName]: { ...dropdowns[stateName], showDropdown: !dropdowns[stateName].showDropdown, }}
    })
  };

  const onSelectDataDropdown = (stateName, value) => {
    setDropdowns(state => {
      return { ...state, [stateName]: { ...dropdowns[stateName], value, showDropdown: !dropdowns[stateName].showDropdown, }}
    })
  }

  const searchUser = async () => {
    setUsers(state => ({ ...state, loading: true, }) )

    const users = await getPartners({ 
      organizationName: organizationName,
    })

    try {
      let resultGet = {}
      resultGet.fetching = false
      resultGet.payload = users
      ProccessData(resultGet, 'get partner')
        .then(({ data }) => {
          setUsers(state => ({ ...state, data, loading: false, }) )
        })
        .catch(err => {
          alert(err ? err : 'ERROR')
        })
    } catch (e) {
      alert('CONNECTION ERROR ' + e)
    }

    setUsers(state => ({ ...state, loading: false, }) )
    setSearched(true)
  }

  const onChangeText = (stateName, value) => {
    setInputValue(state => {
      return { ...state, [stateName]: value, }
    })
  }

  return (
    <Dialog
      {...dialogProps}
      width="36%"
      height={searched ? undefined : "auto"}
      title="Tag new Partner as Caregiver"
      additionalStyle={{
        titleStyle: ` color: ${Colors.color19}; `,
      }}
    >
      <StyledDialogTag>
      <p className="text">Organization Name</p>
        <Input
          inputProps={{
            value: organizationName,
            onChange: (e) => onChangeText('organizationName', e.target.value)
          }}
          containerStyle={`
            ${InputStyle}
            margin-bottom: 26px;
          `}
        />
        {
          searched &&
            <p className="result-text">{users.data.length > 0 ? `Matched result` : `User not found`}</p>
        }
        {
          users.data.length > 0 && searched && 
            [
              users.data.map(item => {
                return (
                  <div className={`card ${userSelected.partnerUid === item.partnerUid && `bordered`}`} onClick={() => {
                    let isTagged = otherAccount.some(data => (data.uidTagged === item.partnerUid && data.status === `ACCEPTED`) || (data.uidTags === item.partnerUid && data.status === `ACCEPTED`))
                    isTagged ? alert(`This user has already been tagged`) : setUserSelected(item)
                  }}>
                  <div className={`card-content`}>
                    <div className="photo-profile-container">
                      <img className="photo-profile" src={item.photo ? item.photo : Images.defaultPhoto} />
                    </div>
                    <div className="text-container">
                      <p className="name-text">{item.organizationName}</p>
                      <p className="phone-text">{item.pocPhone}</p>
                    </div>
                  </div>
                  <div>
                    <img className="check-image" src={userSelected.partnerUid === item.partnerUid ? Images.checkActive : Images.checkInactive} />
                  </div>
                </div>
                )
              }),
              // <p className="text">The Person Living with Dementia is my</p>,
              // renderInputDropdown({
              //   showDropdown: relationship.showDropdown,
              //   dropdownData: relationshipList('CAREGIVER'),
              //   dropdownPropertyName: 'name',
              //   onClick: () => onPressDropdown('relationship'),
              //   onSelectDropdown: ({ name, }) => { 
              //     name === `Don't Filter` ? onSelectDataDropdown(`relationship`, ``) : onSelectDataDropdown(`relationship`, name)
              //   },
              //   value: relationship.value,
              //   placeholder: relationship.placeholder,
              // })  
            ]
        }
        <Row justify='end' style={{ marginTop: '30px' }}>
          <Col md={6}>
            <Button
              text="Discard"     
              backgroundColor={Colors.primaryBgColor}    
              textColor={Colors.color11}
              bordered
              buttonStyle={`border-radius: 15px`} 
              onClick={() => {
                dialogProps.isClose()
                setInputValue({
                  name: '',
                  lastNric: ''
                })
                setUsers({
                  loading: false,
                  data: [],
                })
                setDropdowns({
                  relationship: {
                    showDropdown: false,
                    value: '',
                  },
                })
                setSearched(false)
                setUserSelected({})
                setInputValue({ organizationName: '' })
              }}
            />
          </Col>
          <Col md={6}>
            <Button
              text={users.loading && !searched ? "Searching..." : !users.loading && searched ? "Add" : "Search"}
              disabled={
                users.loading || 
                inputValue.organizationName === '' ||
                (searched && (_.isEmpty(userSelected))) || 
                loadingTag
              }
              backgroundColor={Colors.color10}   
              buttonStyle={`border-radius: 15px`} 
              onClick={() => {
                if (searched && !_.isEmpty(userSelected)) {
                  onTagAccount({ user: userSelected, successTagMessage: `Your Loved One has been successfully added!`, relationship: `Partner`, })
                }

                else searchUser()
              }}
            />
          </Col>
        </Row>
      </StyledDialogTag>
    </Dialog>
  )
}

TagDementia.propTypes = {
  dialogProps: PropTypes.any,
  otherAccount: PropTypes.array,
  onTagAccount: PropTypes.func,
  loadingTag: PropTypes.bool,
}

TagDementia.defaultProps = {
  dialogProps: () => null,
  otherAccount: [],
  onTagAccount: () => null,
  loadingTag: false,
}

export default TagDementia

